import React, { useEffect, useState } from 'react';
import '../../../assets/styles/ServiceStyles/AddServiceStyles/AddService.css';
import AddServiceDetails from './SubComponents/AddServiceDetails';
import ProductOwnerDetails from './SubComponents/ServiceOwnerDetails';
import { FaRegSave, FaWhatsapp } from 'react-icons/fa';
import { TbPhoneCall } from 'react-icons/tb';
import { FiMail } from 'react-icons/fi';
import { MdDeleteOutline } from 'react-icons/md';
import { GetSingleProduct, UpdateAndDeleteProduct } from '../../../services/ProductService/AllProductList/AllProductServices';
import { GetAndCreateAddProducts } from '../../../services/ProductService/AddProducts/AddProducts';
import { useNavigate } from 'react-router-dom';

const AddServices = ({ id, ProductId }) => {

    const navigate = useNavigate()
    const [changeColour, setChangeColour] = useState(null)
    const [showSuccessUpdate, setShowSuccesUpdate] = useState(false)
    const [showConfirmPopup, setShowConfirmPopup] = useState(false)
    const [showSuccessPopup, setShowSuccessPopup] = useState(false)
    const [data, setData] = useState('');
    const [activeTab, setActiveTab] = useState('addProduct');
    const [formData, setFormData] = useState({
        "p_hsn_code_no": "",
        "p_recommended_for": "",
        "product_assign": {
            "admin_emails": [],
            "completed_on": "",
            "comments": "",
            "priority": ""
        },
        "active": null,
        "name": "",
        "p_price": null,
        "p_old_price": null,
        "p_discount": null,
        "p_image_id": "",
        "is_verified": null,
        "p_add_by": "",
        "p_add_date": "",
        "p_add_time": "",
        "p_last_modified_by": "",
        "p_last_add_date": "",
        "p_last_add_time": "",
        "p_owner": "",
        "next_step": "",
        "tag": "",
        "p_id": "",
        "default_unit": "",
        "category_p": "",
        "p_life": null,
        "p_lifespan": "",
        "p_varient": "",
        "p_certification": "",
        "p_description": "",
        "present_stock_status": "",
        "min_order_quantity": null,
        "min_order_quantity_unit": "",
        "production_capacity": null,
        "production_capacity_unit": "",
        "indicative_min_price": null,
        "indicative_max_price": null,
        "production_lead_time": null,
        "attached_product_certificate": "",
        "is_trending": null,
        "p_hsn_code": null,
        "buyer_id": null,
        "seller_id": null,
        "custom_fields": [],
        "buyer_details": null,
        "seller_details": null
    });

    const setServiceManagement = (data) => {
        setFormData((prev) => ({ ...prev, ...data }))
    }

    const setServiceDetails = (data) => {
        setFormData((prev) => ({ ...prev, ...data }))
    };

    const setSelfLifeDetails = (data) => {
        setFormData((prev) => ({ ...prev, ...data }))
    };

    const setServiceDescription = (data) => {
        setFormData((prev) => ({ ...prev, ...data }))
    };

    const UploadSelectedServiceImages = (Serviceimages) =>{
            
    }

    const UploadSelectedCertificatesImages = (Certificatesimages) =>{
        
    }
    const fetchService = async (id) => {
        try {
            const response = await GetSingleProduct('GET', id, {}); // ✅ API call to fetch product by id
            setFormData((prev) => ({ ...prev, ...response.data }))
            console.log(id, response.data);
        } catch (err) {
            console.error('Failed to fetch product data');
        }
    };

    // Function to switch to Product Owner tab
    const handleNextPage =  () => {
        setActiveTab('productOwner');
    };

    const handleAddService = async() =>{
         if (id) {
            try {
               const response = await UpdateAndDeleteProduct('PATCH', id, formData);
                setData('Updated')
                setShowSuccesUpdate(true)
                console.log(id);
                if(response){
                    setTimeout(() => {
                        setShowSuccesUpdate(false)
                        setData('')
                        navigate(`/admin-dashboard/product-module/all-products`);
                    }, 2000)
                }
            } catch (error) {
                console.error('Error:', error);
            }
        } else {
            try {
                await GetAndCreateAddProducts('POST', formData);
                setData('Added')
                setShowSuccesUpdate(true)
                setTimeout(() => {
                    setShowSuccesUpdate(false)
                    setData('')
                }, 2000)
            } catch (error) {
                console.error('Error:', error);
            }
        }
    }

    const handleDeleteSingleProduct = async (id) => {
                if (id) {
                    try {
                        const response = await UpdateAndDeleteProduct('DELETE', id, {});
                        if (response) {
                            setShowConfirmPopup(false);
                            setShowSuccessPopup(true);
                            setTimeout(() => {
                                setShowSuccessPopup(false);
                                    navigate(`/admin-dashboard/product-module/all-products`);
                            }, 1000);
                        }
                    } catch (error) {
                        console.error('Failed to delete product:', error);
                    }
                }
            };

    useEffect(() => {
        if (id) {
            fetchService(id);
        }
        else{
            fetchService(ProductId)
        }
    }, [id]);

    return (
        <div className=' font-normal'>
            <div className='border shadow-lg p-3 rounded-lg '>
                <div className='flex items-center justify-between border-b rounded-lg border-gray-300'>
                    <div>
                        <h1 className='text-gray-600 font-bold px-5 py-3 text-2xl'>{id ? 'Edit Services' : 'Add Services'}</h1>
                    </div>
                    {id ? (
                        <>
                            <div className='flex gap-[15px]'>
                                <div className='flex gap-[5px] rounded-[5px] items-center px-3 py-1 bg-[#25D366] text-[#fff] font-semibold'>
                                    <FaWhatsapp />
                                    <button>Whatsapp</button>
                                </div>
                                <div className='flex gap-[5px] rounded-[5px] items-center px-3 py-1 bg-[#333333] text-[#fff] font-semibold'>
                                    <TbPhoneCall />
                                    <button>Call</button>
                                </div>
                                <div className='flex gap-[5px] rounded-[5px] items-center border border-[#0C92CC] text-[#0C92CC] font-semibold'>
                                    <div className='bg-[#0C92CC] px-2 py-2 text-[#fff]'>
                                        <FiMail />
                                    </div>
                                    <button className='px-2'>Send Mail</button>
                                </div>
                            </div>
                            <div className='flex'>
                                <button className="mr-2 bg-green-600 p-1 px-4 rounded-[5px] text-[#fff] text-xl" onClick={handleNextPage}>
                                    <FaRegSave/>
                                </button>
                                <button className="text-[#fff] px-4 py-1 bg-[#FF0000] text-xl rounded-[5px]" onClick={()=>handleDeleteSingleProduct(id)}>
                                    <MdDeleteOutline />
                                </button>
                            </div>
                        </>
                    ) : null}
                    {id ? (<></>) : (<>
                        {activeTab === 'productOwner' ? (
                            <div className='flex items-center'>
                                <button className='border border-[#FF0000] mx-5 text-[#FF0000] font-bold rounded-xl p-2'>Skip for now</button>
                                <button className='border border-[#FF0000] mx-5 text-white bg-[#FF0000] font-bold p-2 rounded-lg'
                                onClick={handleAddService}>{id ? 'Update Service' : 'Add Service'}</button>
                            </div>
                        ) : (<></>)}
                    </>)}   
                </div>
                <div className=' shadow-custom rounded-xl py-4'>
                    {/* Tabs */}
                    <div className='flex items-center gap-5'>
                        <h1
                            onClick={() => setActiveTab('addProduct')}
                            className={`text-xl px-5 font-bold cursor-pointer 
                            ${activeTab === 'addProduct' ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}
                        `}
                        >
                            Service Details
                        </h1>
                        <h1
                            onClick={() => setActiveTab('productOwner')}
                            className={`text-xl px-5 font-bold cursor-pointer 
                            ${activeTab === 'productOwner' ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}
                        `}
                        >
                            Service Owner Details
                        </h1>
                    </div>

                    {/* Content with Transition */}
                    <div className="relative">
                        <div
                            className={`transition-opacity duration-300 ease-in-out transform ${activeTab === 'addProduct' ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10 absolute'
                                }`}
                        >
                            {id && (
                                <div className="flex justify-end mx-28 -my-5">
                                    <span className="p-1">
                                        <select
                                            name="status"
                                            id="status"
                                            value={formData.active === true ? 'Active' : 'Deactive'}
                                            className={
                                                changeColour
                                                    ? 'bg-green-200 text-green-600 outline-none rounded-lg p-2'
                                                    : 'bg-red-200 text-red-600 outline-none rounded-lg p-2'
                                            }
                                            onChange={(e) => {
                                                const isActive = e.target.value === 'Active';
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    active: isActive
                                                }));
                                                setChangeColour(isActive);
                                            }}>
                                            <option value="Active">Active</option>
                                            <option value="Deactive">Deactive</option>
                                        </select>
                                    </span>
                                </div>
                            )}

                            <AddServiceDetails onNext={handleNextPage} id={id} formData={formData}
                                setServiceManagaementData={setServiceManagement}
                                setServiceDetailsData={setServiceDetails}
                                setSelfLifeData={setSelfLifeDetails}
                                setServiceDescriptionData={setServiceDescription}
                                SelectedServiceImages={UploadSelectedServiceImages}
                                SelectedCertificatesImages={UploadSelectedCertificatesImages} />

                            {/* Success Popup */}
                            {showSuccessUpdate && (
                                <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-md shadow-md">
                                    Product {data} successfully!
                                </div>
                            )}
                        </div>
                        <div
                            className={`transition-opacity duration-300 ease-in-out transform ${activeTab === 'productOwner' ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10 absolute'}`}>
                            <ProductOwnerDetails />
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirmation Popup */}
            {showConfirmPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <div className="text-center">
                            <div className="text-red-500 text-4xl mb-2">❓</div>
                            <p className="text-lg">Do you want to delete this Product?</p>
                        </div>
                        <div className="flex justify-center gap-4 mt-4">
                            <button
                                className="px-4 py-2 border border-red-500 text-red-500 rounded font-bold"
                                onClick={() => setShowConfirmPopup(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-2 bg-red-600 text-white rounded font-bold"
                                onClick={()=>handleDeleteSingleProduct(id)}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showSuccessPopup && (
                <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-md shadow-md">
                    Service deleted successfully!
                </div>
            )}
        </div>
    );
};

export default AddServices;